import Vue from 'vue'
import App from './App.vue'

import 'leaflet/dist/leaflet.css'
// 引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from 'leaflet'

import { hasPermission } from './util'
// Vue.L = Vue.prototype.$L = L

/* leaflet icon */
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import md5 from 'js-md5';

Vue.prototype.$md5 = md5
Vue.prototype.$hasPermission = hasPermission

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)


import map from './assets/map/map.js'
//将map.js挂载到vue上
Vue.prototype.$map = map
import router from './router'

import "./filter"
import store from "./store"

Vue.prototype.$message = function(msg){
    ElementUI.Message(msg)
}
const messageArr = ['success', 'warning', 'info', 'error']

messageArr.forEach(function (type) {
    let configDet = {
        duration: 1200,
        // offset:70
    }
    Vue.prototype.$message[type] = function (message) {
        return ElementUI.Message[type]({
            message,
            ...configDet
        });
    }
})


import {resetForm,selectDictLabel,TreeDictLabel,industryTreeDictLabel} from "./util/common";


import moment from 'moment';
Vue.prototype.$moment = moment;
Vue.prototype.resetForm = resetForm;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.TreeDictLabel = TreeDictLabel;
Vue.prototype.industryTreeDictLabel = industryTreeDictLabel;


import './assets/css/index.less'

Vue.config.productionTip = false

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
